import { useState } from "react";
import { useMoralis } from "react-moralis";
import { Button, Modal } from "antd";

function ConnectWallet() {
  const { authenticate } = useMoralis();
  const [isModalVisible, setIsModalVisible] = useState(true);
  return (
    <Modal
      visible={isModalVisible}
      footer={null}
      onCancel={() => setIsModalVisible(false)}
      bodyStyle={{
        padding: "15px",
        fontSize: "17px",
        fontWeight: "500",
      }}
      style={{ fontSize: "16px", fontWeight: "500" }}
      width="400px"
    >
      Please connect to wallet
      <Button
        size="large"
        type="primary"
        className="primary-button w-100 mt-5 mb-3"
        onClick={() => {
          authenticate({ signingMessage: "Please Sign In" });
          setIsModalVisible(false);
        }}
      >
        Connect to Wallet
      </Button>
    </Modal>
  );
}

export default ConnectWallet;
